import React from "react";
export interface ProductHighLevelProps {
  productDepartment: string;
  productName: string;
  productScent?: string;
  productLevelDescription: string;
  productHighlight: string;
  productId: number;
  hideReviews?: boolean;
}

export const ProductHighlight = ({
  productName,
  productScent,
  productLevelDescription,
  productDepartment,
  productHighlight,
  productId,
  hideReviews = false,
}: ProductHighLevelProps) => {
  return (
    <div className="flex flex-col pb-4 text-left">
      <p className="subtitle text-xs sm:text-sm">{productDepartment}</p>
      <h1 className="title">
        {productName}
        {productScent && <span className="sr-only">{productScent}</span>}
      </h1>
      <p className="body pb-2">{productLevelDescription}</p>

      {hideReviews === false && (
        <div
          data-bv-show="rating_summary"
          data-bv-product-id={productId}
          style={{ minHeight: "18px" }}
        ></div>
      )}
      {productHighlight && <p className="body pt-4">{productHighlight}</p>}
    </div>
  );
};
